import HomeIcon from '../../assets/icons/home.svg?react';
import BriefcaseIcon from '../../assets/icons/briefcase.svg?react';
import AlertIcon from '../../assets/icons/alert.svg?react';
import CalendarIcon from '../../assets/icons/calendar.svg?react';
import { MenuKeys, MenuOption } from '../../types/menu';
import LogbookIcon from '../../assets/icons/logbook.svg?react';

export const menuOptions = new Map<MenuKeys, MenuOption>([
  [
    'home',
    {
      id: 'home',
      name: 'Home',
      to: '/',
      icon: <HomeIcon />,
    },
  ],
  [
    'malfunctions',
    {
      id: 'malfunctions',
      name: 'Malfunctions',
      to: '/malfunctions',
      icon: <AlertIcon />,
      feature: 'MALFUNCTION',
      featureByObject: true,
    },
  ],
  [
    'history',
    {
      id: 'history',
      name: 'History',
      to: '/history',
      icon: <BriefcaseIcon />,
    },
  ],
  [
    'reservations',
    {
      id: 'reservations',
      name: 'Reservations',
      to: '/reservations',
      icon: <CalendarIcon />,
      feature: 'VEHICLE_BOOKING',
    },
  ],
  [
    'logbook',
    {
      id: 'logbook',
      name: 'Logbook',
      to: '/logbook',
      icon: <LogbookIcon />,
      feature: 'LOGBOOK',
    },
  ],
]);
